import { Combiner, CombinerComponent } from './components/Combiner';
import { FilterConfiguration } from './types';

type Props = {
  filter: Combiner;
  configs: FilterConfiguration[];
  setFilters: (filters: Combiner | null) => void;
};

export const FilterPanel = ({ filter, configs, setFilters }: Props) => {
  const onChange = (value: Combiner) => {
    if (value.subFilters.length === 0) {
      setFilters(null);
    } else {
      setFilters(value);
    }
  };

  const onRemove = () => {
    setFilters(null);
  };

  return <CombinerComponent key={filter.id} filters={configs} combiner={filter} onChange={onChange} onRemove={onRemove} />;
};
